<template>
  <add-comment v-if="valueName == 'add_comment'" />
  <attach-file v-else-if="valueName == 'attach_file'" />
  <attach-money v-else-if="valueName == 'attach_money'" />
  <bar-chart v-else-if="valueName == 'bar_chart'" />
  <border-all v-else-if="valueName == 'border_all'" />
  <border-bottom v-else-if="valueName == 'border_bottom'" />
  <border-clear v-else-if="valueName == 'border_clear'" />
  <border-horizontal v-else-if="valueName == 'border_horizontal'" />
  <border-inner v-else-if="valueName == 'border_inner'" />
  <border-left v-else-if="valueName == 'border_left'" />
  <border-outer v-else-if="valueName == 'border_outer'" />
  <border-right v-else-if="valueName == 'border_right'" />
  <border-style v-else-if="valueName == 'border_style'" />
  <border-top v-else-if="valueName == 'border_top'" />
  <border-vertical v-else-if="valueName == 'border_vertical'" />
  <bubble-chart v-else-if="valueName == 'bubble_chart'" />
  <drag-handle v-else-if="valueName == 'drag_handle'" />
  <format-align-center v-else-if="valueName == 'format_align_center'" />
  <format-align-justify v-else-if="valueName == 'format_align_justify'" />
  <format-align-left v-else-if="valueName == 'format_align_left'" />
  <format-align-right v-else-if="valueName == 'format_align_right'" />
  <format-bold v-else-if="valueName == 'format_bold'" />
  <format-clear v-else-if="valueName == 'format_clear'" />
  <format-color-reset v-else-if="valueName == 'format_color_reset'" />
  <format-indent-decrease v-else-if="valueName == 'format_indent_decrease'" />
  <format-indent-increase v-else-if="valueName == 'format_indent_increase'" />
  <format-italic v-else-if="valueName == 'format_italic'" />
  <format-line-spacing v-else-if="valueName == 'format_line_spacing'" />
  <format-list-bulleted v-else-if="valueName == 'format_list_bulleted'" />
  <format-list-numbered v-else-if="valueName == 'format_list_numbered'" />
  <format-list-numbered-rtl
    v-else-if="valueName == 'format_list_numbered_rtl'"
  />
  <format-paint v-else-if="valueName == 'format_paint'" />
  <format-quote v-else-if="valueName == 'format_quote'" />
  <format-shapes v-else-if="valueName == 'format_shapes'" />
  <format-size v-else-if="valueName == 'format_size'" />
  <format-strikethrough v-else-if="valueName == 'format_strikethrough'" />
  <format-textdirection-l-to-r
    v-else-if="valueName == 'format_textdirection_l_to_r'"
  />
  <format-textdirection-r-to-l
    v-else-if="valueName == 'format_textdirection_r_to_l'"
  />
  <format-underlined v-else-if="valueName == 'format_underlined'" />
  <functions v-else-if="valueName == 'functions'" />
  <height v-else-if="valueName == 'height'" />
  <highlight v-else-if="valueName == 'highlight'" />
  <horizontal-rule v-else-if="valueName == 'horizontal_rule'" />
  <insert-chart v-else-if="valueName == 'insert_chart'" />
  <insert-chart-outlined v-else-if="valueName == 'insert_chart_outlined'" />
  <insert-comment v-else-if="valueName == 'insert_comment'" />
  <insert-drive-file v-else-if="valueName == 'insert_drive_file'" />
  <insert-emoticon v-else-if="valueName == 'insert_emoticon'" />
  <insert-invitation v-else-if="valueName == 'insert_invitation'" />
  <insert-link v-else-if="valueName == 'insert_link'" />
  <insert-photo v-else-if="valueName == 'insert_photo'" />
  <linear-scale v-else-if="valueName == 'linear_scale'" />
  <merge-type v-else-if="valueName == 'merge_type'" />
  <mode v-else-if="valueName == 'mode'" />
  <mode-comment v-else-if="valueName == 'mode_comment'" />
  <monetization-on v-else-if="valueName == 'monetization_on'" />
  <money-off v-else-if="valueName == 'money_off'" />
  <money-off-csred v-else-if="valueName == 'money_off_csred'" />
  <multiline-chart v-else-if="valueName == 'multiline_chart'" />
  <notes v-else-if="valueName == 'notes'" />
  <pie-chart v-else-if="valueName == 'pie_chart'" />
  <pie-chart-outline v-else-if="valueName == 'pie_chart_outline'" />
  <post-add v-else-if="valueName == 'post_add'" />
  <publish v-else-if="valueName == 'publish'" />
  <scatter-plot v-else-if="valueName == 'scatter_plot'" />
  <score v-else-if="valueName == 'score'" />
  <short-text v-else-if="valueName == 'short_text'" />
  <show-chart v-else-if="valueName == 'show_chart'" />
  <space-bar v-else-if="valueName == 'space_bar'" />
  <stacked-line-chart v-else-if="valueName == 'stacked_line_chart'" />
  <strikethrough-s v-else-if="valueName == 'strikethrough_s'" />
  <subscript v-else-if="valueName == 'subscript'" />
  <superscript v-else-if="valueName == 'superscript'" />
  <table-chart v-else-if="valueName == 'table_chart'" />
  <table-rows v-else-if="valueName == 'table_rows'" />
  <text-fields v-else-if="valueName == 'text_fields'" />
  <ic-title v-else-if="valueName == 'title'" />
  <vertical-align-bottom v-else-if="valueName == 'vertical_align_bottom'" />
  <vertical-align-center v-else-if="valueName == 'vertical_align_center'" />
  <vertical-align-top v-else-if="valueName == 'vertical_align_top'" />
  <wrap-text v-else-if="valueName == 'wrap_text'" />
</template>

<script>
import AddComment from "@/components/Icons/Editor/AddComment";
import AttachFile from "@/components/Icons/Editor/AttachFile";
import AttachMoney from "@/components/Icons/Editor/AttachMoney";
import BarChart from "@/components/Icons/Editor/BarChart";
import BorderAll from "@/components/Icons/Editor/BorderAll";
import BorderBottom from "@/components/Icons/Editor/BorderBottom";
import BorderClear from "@/components/Icons/Editor/BorderClear";
import BorderHorizontal from "@/components/Icons/Editor/BorderHorizontal";
import BorderInner from "@/components/Icons/Editor/BorderInner";
import BorderLeft from "@/components/Icons/Editor/BorderLeft";
import BorderOuter from "@/components/Icons/Editor/BorderOuter";
import BorderRight from "@/components/Icons/Editor/BorderRight";
import BorderStyle from "@/components/Icons/Editor/BorderStyle";
import BorderTop from "@/components/Icons/Editor/BorderTop";
import BorderVertical from "@/components/Icons/Editor/BorderVertical";
import BubbleChart from "@/components/Icons/Editor/BubbleChart";
import DragHandle from "@/components/Icons/Editor/DragHandle";
import FormatAlignCenter from "@/components/Icons/Editor/FormatAlignCenter";
import FormatAlignJustify from "@/components/Icons/Editor/FormatAlignJustify";
import FormatAlignLeft from "@/components/Icons/Editor/FormatAlignLeft";
import FormatAlignRight from "@/components/Icons/Editor/FormatAlignRight";
import FormatBold from "@/components/Icons/Editor/FormatBold";
import FormatClear from "@/components/Icons/Editor/FormatClear";
import FormatColorReset from "@/components/Icons/Editor/FormatColorReset";
import FormatIndentDecrease from "@/components/Icons/Editor/FormatIndentDecrease";
import FormatIndentIncrease from "@/components/Icons/Editor/FormatIndentIncrease";
import FormatItalic from "@/components/Icons/Editor/FormatItalic";
import FormatLineSpacing from "@/components/Icons/Editor/FormatLineSpacing";
import FormatListBulleted from "@/components/Icons/Editor/FormatListBulleted";
import FormatListNumbered from "@/components/Icons/Editor/FormatListNumbered";
import FormatListNumberedRtl from "@/components/Icons/Editor/FormatListNumberedRtl";
import FormatPaint from "@/components/Icons/Editor/FormatPaint";
import FormatQuote from "@/components/Icons/Editor/FormatQuote";
import FormatShapes from "@/components/Icons/Editor/FormatShapes";
import FormatSize from "@/components/Icons/Editor/FormatSize";
import FormatStrikethrough from "@/components/Icons/Editor/FormatStrikethrough";
import FormatTextdirectionLToR from "@/components/Icons/Editor/FormatTextdirectionLToR";
import FormatTextdirectionRToL from "@/components/Icons/Editor/FormatTextdirectionRToL";
import FormatUnderlined from "@/components/Icons/Editor/FormatUnderlined";
import Functions from "@/components/Icons/Editor/Functions";
import Height from "@/components/Icons/Editor/Height";
import Highlight from "@/components/Icons/Editor/Highlight";
import HorizontalRule from "@/components/Icons/Editor/HorizontalRule";
import InsertChart from "@/components/Icons/Editor/InsertChart";
import InsertChartOutlined from "@/components/Icons/Editor/InsertChartOutlined";
import InsertComment from "@/components/Icons/Editor/InsertComment";
import InsertDriveFile from "@/components/Icons/Editor/InsertDriveFile";
import InsertEmoticon from "@/components/Icons/Editor/InsertEmoticon";
import InsertInvitation from "@/components/Icons/Editor/InsertInvitation";
import InsertLink from "@/components/Icons/Editor/InsertLink";
import InsertPhoto from "@/components/Icons/Editor/InsertPhoto";
import LinearScale from "@/components/Icons/Editor/LinearScale";
import MergeType from "@/components/Icons/Editor/MergeType";
import Mode from "@/components/Icons/Editor/Mode";
import ModeComment from "@/components/Icons/Editor/ModeComment";
import MonetizationOn from "@/components/Icons/Editor/MonetizationOn";
import MoneyOff from "@/components/Icons/Editor/MoneyOff";
import MoneyOffCsred from "@/components/Icons/Editor/MoneyOffCsred";
import MultilineChart from "@/components/Icons/Editor/MultilineChart";
import Notes from "@/components/Icons/Editor/Notes";
import PieChart from "@/components/Icons/Editor/PieChart";
import PieChartOutline from "@/components/Icons/Editor/PieChartOutline";
import PostAdd from "@/components/Icons/Editor/PostAdd";
import Publish from "@/components/Icons/Editor/Publish";
import ScatterPlot from "@/components/Icons/Editor/ScatterPlot";
import Score from "@/components/Icons/Editor/Score";
import ShortText from "@/components/Icons/Editor/ShortText";
import ShowChart from "@/components/Icons/Editor/ShowChart";
import SpaceBar from "@/components/Icons/Editor/SpaceBar";
import StackedLineChart from "@/components/Icons/Editor/StackedLineChart";
import StrikethroughS from "@/components/Icons/Editor/StrikethroughS";
import Subscript from "@/components/Icons/Editor/Subscript";
import Superscript from "@/components/Icons/Editor/Superscript";
import TableChart from "@/components/Icons/Editor/TableChart";
import TableRows from "@/components/Icons/Editor/TableRows";
import TextFields from "@/components/Icons/Editor/TextFields";
import IcTitle from "@/components/Icons/Editor/IcTitle";
import VerticalAlignBottom from "@/components/Icons/Editor/VerticalAlignBottom";
import VerticalAlignCenter from "@/components/Icons/Editor/VerticalAlignCenter";
import VerticalAlignTop from "@/components/Icons/Editor/VerticalAlignTop";
import WrapText from "@/components/Icons/Editor/WrapText";

export default {
  components: {
    AddComment,
    AttachFile,
    AttachMoney,
    BarChart,
    BorderAll,
    BorderBottom,
    BorderClear,
    BorderHorizontal,
    BorderInner,
    BorderLeft,
    BorderOuter,
    BorderRight,
    BorderStyle,
    BorderTop,
    BorderVertical,
    BubbleChart,
    DragHandle,
    FormatAlignCenter,
    FormatAlignJustify,
    FormatAlignLeft,
    FormatAlignRight,
    FormatBold,
    FormatClear,
    FormatColorReset,
    FormatIndentDecrease,
    FormatIndentIncrease,
    FormatItalic,
    FormatLineSpacing,
    FormatListBulleted,
    FormatListNumbered,
    FormatListNumberedRtl,
    FormatPaint,
    FormatQuote,
    FormatShapes,
    FormatSize,
    FormatStrikethrough,
    FormatTextdirectionLToR,
    FormatTextdirectionRToL,
    FormatUnderlined,
    Functions,
    Height,
    Highlight,
    HorizontalRule,
    InsertChart,
    InsertChartOutlined,
    InsertComment,
    InsertDriveFile,
    InsertEmoticon,
    InsertInvitation,
    InsertLink,
    InsertPhoto,
    LinearScale,
    MergeType,
    Mode,
    ModeComment,
    MonetizationOn,
    MoneyOff,
    MoneyOffCsred,
    MultilineChart,
    Notes,
    PieChart,
    PieChartOutline,
    PostAdd,
    Publish,
    ScatterPlot,
    Score,
    ShortText,
    ShowChart,
    SpaceBar,
    StackedLineChart,
    StrikethroughS,
    Subscript,
    Superscript,
    TableChart,
    TableRows,
    TextFields,
    IcTitle,
    VerticalAlignBottom,
    VerticalAlignCenter,
    VerticalAlignTop,
    WrapText,
  },
  props: {
    valueName: {
      type: [String],
    },
  },
};
</script>
